export default class NavAccordion {
	constructor(element) {
		 this.element = element;
		 this.button = this.element.querySelector('.js-trigger-nav-accordion');
		 this.button.addEventListener('click', this.toggleAccordion.bind(this));
	}

	toggleAccordion() {
		 const allElements = document.querySelectorAll('.js-nav-accordion');
		 allElements.forEach(el => {
			  if (el !== this.element && el.classList.contains('open')) {
					el.classList.remove('open');
			  }
		 });

		 this.element.classList.toggle('open');
	}
}
